// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__2wNw2","Search__icon":"Search_Search__icon__fA93B","Search__input":"Search_Search__input__3BaTB"};